/**
 * Money display configuration.
 * Locale tracks the app's UI language (see `@/i18n`), reactively; currency
 * and precision can be overridden here or passed per component.
 */
import { intlLocale } from '@/i18n'

/** ISO 4217 currency code. Default when not passed to component or formatMoney. Override to change app-wide. */
export const defaultCurrency = 'BYN'

/** Reactive locale for formatting (e.g. 'ru-RU'). Default when not passed. Tracks the app's UI language. */
export const defaultLocaleForMoney = intlLocale

/** Decimal places for amount display. Default when not passed. Override to change app-wide. */
export const defaultPrecision = 2
